package dev.lingvo.site.pages.app.projects.slug.screenshots

import dev.lingvo.shared.ScreenshotQuotaDto

/** Downgrades can leave stored bytes above a budget; the text keeps that fact while bars stay bounded. */
fun screenshotUsagePercent(used: Long, limit: Long): Double =
    if (limit <= 0) { if (used > 0) 100.0 else 0.0 } else (used.toDouble() / limit * 100).coerceIn(0.0, 100.0)

fun screenshotStorageFull(quota: ScreenshotQuotaDto): Boolean =
    quota.projectUsedBytes >= quota.projectLimitBytes || quota.workspaceUsedBytes >= quota.workspaceLimitBytes

/** Binary storage budgets are displayed in familiar units, with small nonzero usage kept visible. */
fun screenshotStorageSize(bytes: Long): String {
    val units = listOf("B", "KB", "MB", "GB", "TB")
    var value = bytes.coerceAtLeast(0).toDouble()
    var unit = 0
    while (value >= 1024 && unit < units.lastIndex) { value /= 1024; unit++ }
    val number = if (unit == 0) value.toLong().toString() else if (value < 10) {
        val tenths = kotlin.math.round(value * 10).toLong()
        "${tenths / 10}.${tenths % 10}"
    } else kotlin.math.round(value).toLong().toString()
    return "$number ${units[unit]}"
}
